namespace AgerLMS {
    export namespace PermissionKeys {
        export const ZoomPage = "LMS:Zoom:Page";
        export const GENERAL = "General:";
        export const GeneralPanel = "General:Panel";
        export const GeneralStudentPanel = "General:StudentPanel";
        export const Lms = "LMS";
        export const SiteSetting = "LMS:SiteSetting:";
        export const SiteSettingRead = "LMS:SiteSetting:Read";
        export const SiteSettingModify = "LMS:SiteSetting:Modify";
        export const SiteSettingPage = "LMS:SiteSetting:Page";
        export const Course = "LMS:Course:";
        export const CourseRead = "LMS:Course:Read";
        export const CourseModify = "LMS:Course:Modify";
        export const NewCoursePage = "LMS:Course:NewCoursePage";
        export const CoursesPage = "LMS:Course:CoursesPage";
        export const Bundle = "LMS:Bundle:";
        export const BundleRead = "LMS:Bundle:Read";
        export const BundleModify = "LMS:Bundle:Modify";
        export const NewBundlePage = "LMS:Bundle:NewBundlePage";
        export const BundlesPage = "LMS:Bundle:BundlesPage";
        export const Product = "LMS:Product:";
        export const ProductRead = "LMS:Product:Read";
        export const ProductModify = "LMS:Product:Modify";
        export const NewProductPage = "LMS:Product:NewProductPage";
        export const ProductsPage = "LMS:Product:ProductsPage";
        export const Quiz = "LMS:Quiz:";
        export const QuizRead = "LMS:Quiz:Read";
        export const QuizModify = "LMS:Quiz:Modify";
        export const QuizzesPage = "LMS:Quiz:Page";
        export const QuizStartPage = "LMS:Quiz:QuizStartPage";
        export const QuizResultPage = "LMS:Quiz:QuizResultPage";
        export const MyQuizResultsPage = "LMS:Quiz:MyQuizResultsPage";
        export const MyQuizzesPage = "LMS:Quiz:MyQuizzesPage";
        export const LmsCategory = "LMS:LmsCategory:";
        export const LmsCategoryRead = "LMS:LmsCategory:Read";
        export const LmsCategoryModify = "LMS:LmsCategory:Modify";
        export const LmsCategoriesPage = "LMS:LmsCategory:Page";
        export const Discount = "LMS:Discount:";
        export const DiscountRead = "LMS:Discount:Read";
        export const DiscountModify = "LMS:Discount:Modify";
        export const DiscountsPage = "LMS:Discount:Page";
        export const Badge = "LMS:Badge:";
        export const BadgeRead = "LMS:Badge:Read";
        export const BadgeModify = "LMS:Badge:Modify";
        export const BadgesPage = "LMS:Badge:Page";
        export const Order = "LMS:Order:";
        export const OrderRead = "LMS:Order:Read";
        export const OrderModify = "LMS:Order:Modify";
        export const OrderConfirmPage = "LMS:Order:OrderConfirmPage";
        export const OrderItem = "LMS:OrderItem:";
        export const OrderItemRead = "LMS:OrderItem:Read";
        export const OrderItemModify = "LMS:OrderItem:Modify";
        export const PurchasedWebinarsPage = "LMS:OrderItem:PurchasedWebinarsPage";
        export const PurchasedProductsPage = "LMS:OrderItem:PurchasedProductsPage";
        export const LMSComment = "LMS:LMSComment:";
        export const LMSCommentRead = "LMS:LMSComment:Read";
        export const LMSCommentModify = "LMS:LMSComment:Modify";
        export const LmsCommentPage = "LMS:LMSComment:LmsCommentPage";
        export const MyWebinarCommentsPage = "LMS:LMSComment:MyWebinarCommentsPage";
        export const MyProductCommentsPage = "LMS:LMSComment:MyProductCommentsPage";
        export const Faq = "LMS:Faq:";
        export const FaqRead = "LMS:Faq:Read";
        export const FaqModify = "LMS:Faq:Modify";
        export const FaqPage = "LMS:Faq:FaqPage";
        export const FaqSitePage = "LMS:Faq:FaqSitePage";
        export const CmsPage = "LMS:CmsPage:";
        export const LMSCmsPageRead = "LMS:CmsPage:Read";
        export const LMSCmsPageModify = "LMS:CmsPage:Modify";
        export const LmsCmsPagePage = "LMS:CmsPage:CmsPagePage";
        export const Slider = "CMS:Slider:";
        export const SliderRead = "CMS:Slider:Read";
        export const SliderModify = "LMS:CmsPage:Modify";
        export const SliderPage = "CMS:Slider:SliderPage";
        export const QuizQuestion = "LMS:QuizQuestion:";
        export const QuizQuestionRead = "LMS:QuizQuestion:Read";
        export const QuizQuestionModify = "LMS:QuizQuestion:Modify";
        export const QuizQuestionPage = "LMS:QuizQuestion:QuizQuestionPage";
        export const Logging = "Logging";
        export const SmsSendLog = "Logging:SmsSendLog:";
        export const SmsSendLogRead = "Logging:SmsSendLog:Read";
        export const SmsSendLogModify = "Logging:SmsSendLog:Modify";
        export const SmsSendLogPage = "Logging:SmsSendLog:Page";
        export const ManuelSmsSendPage = "Logging:ManuelSmsSend:Page";
        export const UserEventLog = "Logging:UserEventLog:";
        export const UserEventLogRead = "Logging:UserEventLog:Read";
        export const UserEventLogModify = "Logging:UserEventLog:Modify";
        export const UserEventLogPage = "Logging:UserEventLog:Page";
        export const LessonWatchLog = "Logging:LessonWatchLog:";
        export const LessonWatchLogRead = "Logging:LessonWatchLog:Read";
        export const LessonWatchLogInsert = "Logging:LessonWatchLog:Insert";
        export const LessonWatchLogUpdate = "Logging:LessonWatchLog:Update";
        export const LessonWatchLogDelete = "Logging:LessonWatchLog:Delete";
        export const LessonWatchLogPage = "Logging:LessonWatchLog:Page";
        export const UserQuizAnswer = "Logging:UserQuizAnswer:";
        export const UserQuizAnswerRead = "Logging:UserQuizAnswer:Read";
        export const UserQuizAnswerModify = "Logging:UserEventLog:Modify";
        export const UserQuizAnswerPage = "Logging:UserQuizAnswer:Page";
        export const LmsNotificationLog = "Logging:LmsNotification:";
        export const LmsNotificationRead = "Logging:LmsNotification:Read";
        export const LmsNotificationInsert = "Logging:LmsNotification:Insert";
        export const LmsNotificationUpdate = "Logging:LmsNotification:Update";
        export const LmsNotificationDelete = "Logging:LmsNotification:Delete";
        export const MyNotificationsPage = "Logging:LmsNotification:MyNotifications";
        export const LmsNotificationPage = "Logging:LmsNotification:Page";
        export const UserActivity = "Logging:UserActivity:";
        export const UserActivityRead = "Logging:UserActivity:Read";
        export const UserActivityPage = "Logging:UserActivity:Page";
    }
}
